export default __webpack_public_path__ + "static/media/d571d0bbbd684f76d0ece8f5946a1ece.svg";